const API_URL = process.env.REACT_APP_API_URL;

class CheckoutService {
  async previewCheckout(payload) {
    const res = await fetch(`${API_URL}/checkout/preview`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to preview checkout');
    }
    return res.json();
  }

  async createCheckoutSession(payload) {
    const res = await fetch(`${API_URL}/checkout/create-session`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create checkout session');
    }
    return res.json();
  }

  async createInvoiceOrder(payload) {
    const res = await fetch(`${API_URL}/checkout/invoice`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create invoice');
    }
    return res.json();
  }

  async createMonthlyOrder(payload) {
    const res = await fetch(`${API_URL}/checkout/monthly`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create monthly order');
    }
    return res.json();
  }

  async confirmOrder(orderId) {
    const response = await fetch(`${API_URL}/checkout/success`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify({ orderId })
    });

    if (!response.ok) {
      const error = await response.json();
      throw new Error(error.error || 'Failed to confirm order');
    }

    return response.json();
  }

  async createPaymentIntent(payload) {
    const res = await fetch(`${API_URL}/checkout/create-payment-intent`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include',
      body: JSON.stringify(payload),
    });
    if (!res.ok) {
      const errorData = await res.json().catch(() => ({}));
      throw new Error(errorData.error || 'Failed to create payment');
    }
    return res.json();
  }
}

const checkoutService = new CheckoutService();
export default checkoutService;
